import {
    Component,
    OnInit
} from '@angular/core';
import {
    Constants
} from '../Services/Constants';
import {
    HTTPService
} from '../Services/http.service';
import {
    Observable
} from 'rxjs/Observable';
import {
    filter
} from '../App/search.pipe';
import {
    DatePipe
} from "@angular/common";
import {
    MySharedService
} from '../App/shared.service';
import {
    ActivatedRoute,
    Router
} from '@angular/router';



declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns ? : any): void;

@Component({
    templateUrl: './AppViews/Vendors/vendorsAdd.html'
})

export class VendorsAddComponent {
    public addVendorData: any = {
        Country: "",
        PaymentType: "",
        PaymentMode: "",
        Status: "",
        Grades: "",
        addvendorIsActive: true,
        City: "",
        State: ""
    };
    VendorGrades: any;
    userDetail: any;
    PaymentType: any;
    StausOrg: any;
    CountryInfo: any;
    PaymentMode: any;
    cityData: any = [];
    stateData: any = [];
    public constants: Constants;
    public showLoader = false;
    public isFormSubmitted: boolean = false;
    public isthirdFormSubmitted: boolean = false;
    public isSecondFormSubmitted: boolean = false;
    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private _route: Router) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
    }

    ngOnInit() {
        this.getVendorGrades();
        this.getPaymentType();
        this.getorganizationStatus();
        this.getPaymentMode();
        this.getCountry();
        this.GetCityData();
        this.GetStateData();

        $('.registration-form fieldset:first-child').fadeIn();

        $('#top-navbar-1').on('shown.bs.collapse', function () {
            //$.backstretch("resize");
        });
        $('#top-navbar-1').on('hidden.bs.collapse', function () {
            //$.backstretch("resize");
        });

        /*
            Form
        */
        $('.registration-form fieldset:first-child').fadeIn();

        $('.registration-form input[type="text"], .registration-form input[type="password"], .registration-form textarea').on('focus', function () {
            $(this).removeClass('input-error');
        });

        // next step
        $('.registration-form .btn-next').on('click', function () {
            var parent_fieldset = $(this).parents('fieldset');
            var next_step = true;

            parent_fieldset.find('input[id="form-Name"],input[id="form-Address"],input[id="form-PinCode"],input[id="Country"],input[id="form-Pname"],input[id="form-Phone"],input[id="form-Mobile"],input[id="form-Email"], textarea')
                .each(function () {
                    if ($(this).val() == "") {
                        $(this).addClass('input-error');
                        next_step = false;
                    } else {
                        $(this).removeClass('input-error');
                    }
                });

            if (next_step) {
                parent_fieldset.fadeOut(400, function () {
                    $(this).next().fadeIn();
                });
            }

        });

        // previous step
        $('.registration-form .btn-previous').on('click', function () {
            $(this).parents('fieldset').fadeOut(400, function () {
                $(this).prev().fadeIn();
            });
        });

        // submit
        $('.registration-form').on('submit', function (e) {

            $(this).find('input[type="text"], input[type="password"], textarea').each(function () {
                if ($(this).val() == "") {
                    e.preventDefault();
                    $(this).addClass('input-error');
                } else {
                    $(this).removeClass('input-error');
                }
            });

        });
    }

    GetCityData() {
        this._httpService.ajaxPost('Common/GetCity').subscribe(
            data => {
                this.cityData = data["Cities"];
            },
            err => {
                console.log("GetCityData Failed with status: " + err.status);
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
        setTimeout(function () {
            $(".pop-comment").popover({
                //content: 'test'
                content: function () {
                    return $(this).parent().find('p').html();
                }
            });
        }, 500);
    }

    GetStateData() {
        this._httpService.ajaxPost('Common/GetState').subscribe(
            data => {
                this.stateData = data["States"];
            },
            err => {
                console.log("GetStateData Failed with status: " + err.status);
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
        setTimeout(function () {
            $(".pop-comment").popover({
                //content: 'test'
                content: function () {
                    return $(this).parent().find('p').html();
                }
            });
        }, 500);
    }


    public getVendorGrades() {
        this.showLoader = true;
        this._httpService.ajaxPost('Common/GetParameter', {
            "ParameterTypeId": this.constants.enumParamterTypeName["VendorGrade"]
        }).subscribe(
            data => {
                this.VendorGrades = data["Parameter"];
            },
            err => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public getPaymentType() {
        this.showLoader = true;
        this._httpService.ajaxPost('Common/GetParameter', {
            "ParameterTypeId": this.constants.enumParamterTypeName["Currency"]
        }).subscribe(
            data => {
                this.PaymentType = data["Parameter"];
            },
            err => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public getPaymentMode() {
        this.showLoader = true;
        this._httpService.ajaxPost('Common/GetParameter', {
            "ParameterTypeId": this.constants.enumParamterTypeName["PaymentMode"]
        }).subscribe(
            data => {
                this.PaymentMode = data["Parameter"];
            },
            err => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public getorganizationStatus() {
        this.showLoader = true;
        this._httpService.ajaxPost('Common/GetParameter', {
            "ParameterTypeId": this.constants.enumParamterTypeName["OrganizationStatus"]
        }).subscribe(
            data => {
                this.StausOrg = data["Parameter"];
            },
            err => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public getCountry() {
        this.showLoader = true;
        this._httpService.ajaxPost('Common/GetParameter', {
            "ParameterTypeId": this.constants.enumParamterTypeName["Country"]
        }).subscribe(
            data => {
                this.CountryInfo = data["Parameter"];
            },
            err => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public resetVedorForm(form: any) {
        form.reset();
        form.resetForm();
        this.isFormSubmitted = false;
        //setTimeout(() => this.addCustomerData.addCustomerIsActive = true, 0);
    }

    validation(form: any) {
        this.isFormSubmitted = true;
    }

    Formvalidation(form: any) {
        this.isSecondFormSubmitted = true;
    }

    isFormvalidation() {
        this.isthirdFormSubmitted = true;
    }

    public AddVendors(form: any) {
        this.isFormvalidation();
        let objItem: any = {};
        objItem.VendorId = 0;
        objItem.CompanyName = this.addVendorData.VendorName;
        objItem.Address = this.addVendorData.VendorAddress;
        objItem.Pincode = this.addVendorData.Pincode;
        objItem.Country = parseInt(this.addVendorData.Country);
        objItem.ContactPerson = this.addVendorData.Contactname
        objItem.Phone = this.addVendorData.Phone;
        objItem.MobileNo = this.addVendorData.Mobile;
        objItem.Email = this.addVendorData.Email;
        if (this.addVendorData.AltEmail != undefined) {
            objItem.AlternateEmail = this.addVendorData.AltEmail;
        } else {
            objItem.AlternateEmail = null;

        }
        objItem.StatusOfOrganisation = this.addVendorData.Status;
        objItem.BankName = this.addVendorData.BankName;
        objItem.BankAccountNumber = this.addVendorData.BankAccountNo;
        objItem.IFSCCode = this.addVendorData.IFSC;
        objItem.Currency = parseInt(this.addVendorData.PaymentType);
        objItem.SwiftCode = this.addVendorData.Swift;
        if (this.addVendorData.Credit != undefined) {
            objItem.PaymentCredit = this.addVendorData.Credit;
        } else {
            objItem.PaymentCredit = null;
        }
        objItem.PaymentMode = parseInt(this.addVendorData.PaymentMode);
        objItem.PanCardNumber = this.addVendorData.PAN;
        if (this.addVendorData.VAT != undefined) {
            objItem.VATNo = this.addVendorData.VAT;
        } else {
            objItem.VATNo = null;
        }
        if (this.addVendorData.CST != undefined) {
            objItem.CSTNo = this.addVendorData.CST;
        } else {
            objItem.CSTNo = null;

        }
        if (this.addVendorData.Tax != undefined) {
            objItem.ServiceTaxNumber = this.addVendorData.Tax;
        } else {
            objItem.ServiceTaxNumber = null;
        }


        objItem.GSTNo = this.addVendorData.GST;
        objItem.GradeId = this.addVendorData.Grades;
        if (this.addVendorData.addvendorIsActive == true) {
            objItem.Is_Active = 1
        } else {
            objItem.Is_Active = 0
        }
        objItem.Is_Active = this.addVendorData.addvendorIsActive;
        objItem.CityId = this.addVendorData.City;
        objItem.StateId = this.addVendorData.State;



        this.addEditVendors(objItem);
    }


    navigate() {
        this._route.navigateByUrl("/vendors");
    }

    addEditVendors(objItem) {
        this.showLoader = true;

        this._httpService.ajaxPost('Vendors/AddUpdateVendors', objItem).subscribe(
            data => {

                var msg = data["Status"].Message.split('|');
                if (msg.length > 1) {
                    msg[0] = msg[0].toLowerCase();
                    this._sharedService.ShowMessage(data["Status"].Message);
                    this.navigate()
                } else {
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);

            },

            () => {
                this.showLoader = false;

            }
        );
    }

    public autoSelectState(isEdit: boolean) {
        if (this.addVendorData.City)
            this.addVendorData.State = this.cityData.filter((city) => city.CityId == this.addVendorData.City)[0].StateId;
    }

}


/** WEBPACK FOOTER **
 ** ./TypeScripts/Vendors/vendorsAdd.component.ts
 **/